import { FC } from 'react'
import s from './index.module.scss'

type Props = {
  text: string
}

const SharedDisclaimer: FC<Props> = ({text}) => {
  return (
    <div className={s.root}>
      <div className={s.container} dangerouslySetInnerHTML={{__html: text}} />
    </div>
  )
}

export default SharedDisclaimer
